import { call, CallEffect, PutEffect } from 'redux-saga/effects'

import { AxiosResponse } from 'axios'
import { Action } from 'redux-saga';
import { automaticApi } from '@/settings/api';

export interface Fetch {
    plate: string;
    identifier: string;
    callback: (success: boolean) => void;
}

export interface DeleteVehicleAction {
    type: string;
    payload: Fetch;
}

const uri = '/tags/v1/cancel'

export default function* deleteVehicle({
    payload,
}: DeleteVehicleAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const body = {
            plate: payload.plate,
            identifierTag: payload.identifier,
        };

        const res: AxiosResponse = yield call(automaticApi.post, uri, body);

        if (String(res?.data?.processStatus ?? "")?.toLocaleLowerCase()?.includes("success")) {
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false);
        }
    } catch (error) {
        yield call(payload.callback, false);
    }
}
